import { __awaiter } from "tslib";
import React from 'react';
import { Tooltip } from 'antd';
import { useXFlowApp, createComponentModel, XFlowAppExtensionModule } from '@antv/xflow-core';
import { ACTIVE_NODE_PORT } from '../interface';
import { createModule } from '../module';
export const CONFIG_TYPE = 'CanvasNodePortTooltip';
const RenderTooltip = props => {
    const xflow = useXFlowApp();
    const [state, , renderModel] = createComponentModel(null);
    React.useEffect(() => {
        if (!xflow) {
            return;
        }
        const subscribe = () => __awaiter(void 0, void 0, void 0, function* () {
            const { model } = yield ACTIVE_NODE_PORT.useModel(xflow.modelService);
            return model.watch(value => {
                renderModel.setValue(value);
            });
        });
        const subscription = subscribe();
        return () => {
            subscription.then(disposable => {
                disposable.dispose();
            });
        };
    }, [renderModel, xflow]);
    const visible = !!(state && state.position && state.position.x);
    if (!visible) {
        return null;
    }
    const title = props.getTooltip ? props.getTooltip(state) : state.tooltip;
    return (React.createElement(Tooltip, { visible: visible, title: title, placement: state.placement || 'top' },
        React.createElement("span", { className: "canvas-node-port-tooltip", style: { position: 'absolute', left: state.position.x, top: state.position.y } })));
};
export const CanvasNodePortTooltip = props => {
    const getConfig = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () { return null; }), []);
    return (React.createElement(XFlowAppExtensionModule, { createModule: createModule, config: { CONFIG_TYPE: CONFIG_TYPE, getConfig } },
        React.createElement(RenderTooltip, Object.assign({}, props))));
};
//# sourceMappingURL=index.js.map